export enum ListOfFactory {
    RSNIS = 'RSNIS',
    RS7Z = 'RS7Z'
};

export enum ProcessType {
    ARC = 'ARC',
    ADC = 'ADC',
    CDS = 'CDS',
    MLC = 'MLC',
    AWRC = 'AWRC',
    AWRC_GRAPHQL = 'AWRC_GRAPHQL',
    ALARM = 'ALARM',
    HEALTHCHECK = 'HEALTHCHECK',
    WINCC = 'WINCC',
    BAL = 'BAL',
    ACKNOWLEDGE = 'ACKNOWLEDGE',
    CONFIG = 'CONFIG',
    CHART = 'CHART',
    FACTORY = 'FACTORY'
};

export enum ALCProcessors {
    ARC = 'ARC',
    ADC = 'ADC',
    CDS = 'CDS',
}

export enum ProcessLine {
    DCCC1 = 'DCCC1',
    DCCC2 = 'DCCC2',
    NO_LINE = ''
}

export enum SolutionState {
    RUNNING = 'RUNNING',
    FINISHED = 'FINISHED',
    CRITICAL = 'CRITICAL',
    ERROR = 'ERROR'
}

export enum Area {
    INTB = 'intb',
    TBCF = 'tbcf'
}

export enum Environment {
    DEV = 'dev',
    QA = 'qa',
    PRD = "prd"
}